export default __webpack_public_path__ + "assets/images/5369084ce443df315f46d568c7717e99.svg";